import { ReportType } from "../typings/global";
import tools from "../utils/tools";
import util from "../utils/util";
import Console from "../utils/console";
import Collecter from "./collecter";

export default class Reporter {
  host: string | undefined;
  request: any;
  console: Console;
  openReport: boolean;
  timer: any;
  freq: number;

  constructor() {
    this.console = new Console();
  }

  setConfig(config: ReportType.GConfig) {
    const { RepotHost, PlatformRequest, OpenReport, ReportFreq } = config;
    this.host = RepotHost;
    this.request = PlatformRequest || tools.post;
    this.openReport = !!OpenReport;
    this.freq = util.isNum(ReportFreq) ? ReportFreq || 0 : 0;
    this.console.setConfig(config);
  }

  _report(data: any) {
    if (!this.host) {
      this.console.warn("host is null");
      return;
    }

    if (!this.request) {
      this.console.warn("request is null");
      return;
    }

    try {
      const timestamp = Date.now();
      this.console.log("reporting: ", JSON.stringify(data));

      // 数据加密
      const postData = tools.xEncode(data, timestamp);
      const url = `${this.host}?ts=${timestamp}`;

      return this.request(url, postData);
    } catch (err) {
      this.console.warn("report fail:", err);
    }
  }

  /**
   * 上报
   * @param collecter 日志收集器
   * @param immedit 是否直接上报
   * @param useFreq 是否开启定频
   */
  report(collecter: Collecter, immedit?: boolean, useFreq?: boolean) {
    // 关闭上报
    if (!this.openReport) {
      this.console.warn("report is closed");
      return;
    }

    // 参数异常
    if (!collecter) {
      this.console.warn("collecter is null");
      return;
    }

    try {
      // 定频 && 上报冷却中
      if (useFreq && this.timer) return;

      // 上报
      if (immedit) {
        const data = collecter.collect();
        // 无上报数据
        if (!data) return;

        // 上报数据
        this._report(data);
        collecter.clear();
      }

      // 不定频
      if (!useFreq) return;

      // 定频
      this.timer = setTimeout(
        () => this.clearTimer().report(collecter, true, true),
        this.freq
      );
    } catch (err) {
      this.clearTimer();
      this.console.warn("report fail:", err);
    }
  }

  clearTimer() {
    try {
      this.timer && clearTimeout(this.timer);
    } catch (err) {
      this.console.warn("report clear fail:", err);
    }
    this.timer = null;
    return this;
  }
}
